import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/logistics/orders")({
  component: OrdersLayout,
});

function OrdersLayout() {
  return (
    <RouteGuard module="logistics_orders" action="read">
      <Outlet />
    </RouteGuard>
  );
}
